import { createSelector } from 'reselect';

import { getProps } from 'modules/notifications/selectors';
import { getState as getParent } from 'modules/notifications/selectors/data';

const getState = createSelector(getParent, ({ byId } = {}) => byId ?? {});

/** @typedef {import('modules/notifications/types').Notification} Notification */

/** @returns {Array<Notification>} */
export const getNotifications = createSelector(getState, byId => Object.values(byId ?? {}));

/** @returns {Notification} */
export const getNotificationById = createSelector(getState, getProps, (byId, id) => byId[id]);

/** @returns {Array<Notification>} */
export const getNotificationsByIds = createSelector(getState, getProps, (byId, ids) =>
  (Array.isArray(ids) ? ids.map(id => byId[id]) : []));
